import { render, staticRenderFns } from "./serveCompanyDialog.vue?vue&type=template&id=681647ec&scoped=true&"
import script from "./serveCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./serveCompanyDialog.vue?vue&type=script&lang=js&"
import style0 from "./serveCompanyDialog.vue?vue&type=style&index=0&id=681647ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681647ec",
  null
  
)

export default component.exports